export const BILLING_TYPES = [
  { value: "personal", label: "personal" },
  { value: "business", label: "business" },
];
